/** "Updated today" / "yesterday" / "5d ago" / "12 Mar" — short and scannable. */
export function formatRelativeDate(isoString) {
  if (!isoString) return '';
  const then = new Date(isoString);
  const now = new Date();
  const days = Math.floor((now - then) / (1000 * 60 * 60 * 24));

  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days}d ago`;
  return then.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}
